import { Card, Box, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

type DashboardStatsItemProps = {
  title: string;
  description: string;
  icon: SvgIconComponent;
};
export default function DashboardStatsItem({
  title,
  description,
  icon: Icon,
}: DashboardStatsItemProps) {
  return (
    <Card sx={{ py: 2, px: 4, width: 1 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <Icon color="primary" />
        <Typography variant="body1" sx={{fontWeight:1000,fontSize:18}}>
          {title}
        </Typography>
      </Box>
      <Typography sx={{padding:1}} variant="body1">{description}</Typography>
    </Card>
  );
}
